<template>
  <CommonPopup
    :title="$t('meu.Saque.Title')"
    cancelBtn
    :confirmText="$t('meu.Saque.confirmText')"
    :onConfirm="
      () => {
        const currentPath = $router.currentRoute.value.path;
        if (currentPath.includes('game')) {
          flowStore.show('SaquePw');
        } else {
          $router.push('/saquepw');
        }
      }
    "
    :cancelText="$t('meu.Saque.cancelText')"
  >
    <img :src="THEME_A + '/assets/images/pic_saque.png'" class="size-25 my-4" alt="" />
    <p class="text-14 font-[500] leading-20 text-center">
      {{ $t("meu.Saque.Content") }}
    </p>
  </CommonPopup>
</template>

<script setup lang="ts">
import CommonPopup from '@/components/commonPopup/index.vue'
import { useGameFlowStore } from "@/store";
import { THEME_A } from '@/consts'
const flowStore = useGameFlowStore();
</script>
